import { Link } from 'react-router-dom'
import './Logo.css'

const HouseIcon = () => (
  <svg
    className="logo__icon"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M20 4L4 18v16h8V22h16v12h8V18L20 4z"
      fill="currentColor"
    />
    <path
      d="M20 4l-4 3.5V10h8V7.5L20 4z"
      fill="currentColor"
      opacity="0.85"
    />
  </svg>
)

function Logo({ brand, className = '' }) {
  const mainText = brand?.name || 'PROBANDO'
  const subText = brand?.tagline || 'AUTOMOTORA'

  return (
    <Link to="/" className={`logo ${className}`}>
      {brand?.logo ? (
        <img src={brand.logo} alt={mainText} className="logo__img" />
      ) : (
        <>
          <HouseIcon />
          <span className="logo__text">
            <span className="logo__main">{mainText}</span>
            <span className="logo__sub">{subText}</span>
          </span>
        </>
      )}
    </Link>
  )
}

export default Logo
